import React from 'react'
import FormLabel from './FormLabel'
import FormField from './FormField'
import styles from './FormDateSelector.module.scss'
import { ReactComponent as CalendarIcon } from 'components/UI/icons/calendar-line.svg'
import PropTypes from 'prop-types'
import DatePicker, { registerLocale } from 'react-datepicker'
import FormInput from './FormInput'
import { timeConverter2 } from 'components/ContentBox/Online-schedule/components/functions'
import { getLang } from 'hooks/useLocalization'
import kk from 'date-fns/locale/kk'
import DatePickerWrapper from 'components/UI/DatePickerWrapper'
import CustomSelect from 'components/UI/CustomSelect/CustomSelect'
import { monthsData } from 'components/UI/Calendar/utils.js'
import { years } from 'components/UI/Calendar/utils.js'

export default function FormDateSelector(props) {
  const onClickButtonHandler = (action) => {
    return action === 'today'
      ? props.onChange(new Date())
      : props.onChange(null)
  }
  registerLocale('kz', kk)

  const DpCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className={styles.inputContainer} onClick={onClick} ref={ref}>
      <CalendarIcon className={styles.calendarIcon} />
      <FormInput isError={props.error}>
        <input
          value={value}
          className={styles.input}
          placeholder={props.placeholder}
          type='text'
          onChange={() => {}}
        />
      </FormInput>
    </div>
  ))

  return (
    <FormField flexBasis={props.flexBasis}>
      <FormLabel isRequired={props.isRequired}>
        {props.label}
        {props.button && (
          <span
            className={styles.action}
            onClick={() => onClickButtonHandler(props.button.action)}
          >
            {props.button && props.button.name}
          </span>
        )}
      </FormLabel>
      <DatePickerWrapper>
        <DatePicker
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div className={styles.customHeaderSelect}>
              <div className={styles.selectMonth}>
                <div className={styles.dateName}>Month</div>
                <CustomSelect
                  options={monthsData}
                  onSelect={(option) => changeMonth(monthsData.indexOf(option))}
                  defaultValue={monthsData[date.getMonth()]}
                />
              </div>
              <div className={styles.selectYear}>
                <div className={styles.dateName}>Year</div>
                <CustomSelect
                  options={years}
                  onSelect={(option) => changeYear(option)}
                  defaultValue={date.getFullYear()}
                />
              </div>
            </div>
          )}
          selected={
            props.selected
              ? new Date(props.selected)
              : props.value
                ? new Date(props.value)
                : null
          }
          onChange={(date) => props.onChange(timeConverter2(date))}
          minDate={props.minDate}
          maxDate={props.maxDate}
          excludeDates={props.excludeDates}
          locale={getLang()}
          dateFormat={'yyyy-MM-dd'}
          disabled={props.disabled}
          customInput={<DpCustomInput />}
          withPortal
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
        />
      </DatePickerWrapper>
    </FormField>
  )
}

FormDateSelector.propTypes = {
  button: PropTypes.shape({
    name: PropTypes.string,
    action: PropTypes.string,
  }),
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  excludeDates: PropTypes.array,
}
